import React from "react";
import Filter from "../../../components/common/Filter";
import SearchBar from "../../../components/common/SearchBar";
import { platformOptions } from "../constants/notificationConstants";

const DeviceFilterBar = ({ filters, onFilterChange }) => {
  const handlePlatformChange = (platform) => {
    onFilterChange({ platform: platform === "All" ? "" : platform });
  };

  const handleActiveChange = (status) => {
    onFilterChange({
      isActive: status === "All" ? "" : status === "Active" ? "true" : "false",
    });
  };

  const handleSearchChange = (search) => {
    onFilterChange({ search });
  };

  return (
    <div className="flex flex-col gap-4 mb-6">
      <div className="w-full">
        <SearchBar
          placeholder="Search by device ID, user, or model..."
          value={filters.search}
          onChange={handleSearchChange}
        />
      </div>

      <div className="flex flex-wrap gap-2">
        <div className="flex-grow sm:flex-grow-0 min-w-[100px]">
          <Filter
            label="Platform"
            options={["All", "IOS", "ANDROID", "WEB"]}
            defaultOption="All"
            onSelect={handlePlatformChange}
          />
        </div>

        <div className="flex-grow sm:flex-grow-0 min-w-[100px]">
          <Filter
            label="Status"
            options={["All", "Active", "Inactive"]}
            defaultOption="All"
            onSelect={handleActiveChange}
          />
        </div>

        <div className="flex-grow sm:flex-grow-0 min-w-[100px]">
          <Filter
            label="App Version"
            options={["All", "Latest", "Outdated"]}
            defaultOption="All"
            onSelect={(version) =>
              onFilterChange({
                "appInfo.version": version === "All" ? "" : version,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DeviceFilterBar;
